import { Link, useLocation } from "react-router-dom";
import { Home, Grid3X3, ShoppingCart, Coins, Shield, Store } from "lucide-react";
import { useCart } from "@/hooks/useCart";
import { useAuth } from "@/hooks/useAuth";
import { usePoints } from "@/hooks/usePoints";
import { motion } from "framer-motion";

const MobileBottomNav = () => {
  const location = useLocation();
  const { itemCount, setIsOpen: openCart } = useCart();
  const { user, isAdmin, isVendor } = useAuth();
  const { balance: pointsBalance } = usePoints();

  const tabs = [
    { icon: Home, label: "בית", path: "/" },
    { icon: Grid3X3, label: "קטגוריות", path: "/קטגוריות" },
    ...(isAdmin ? [{ icon: Shield, label: "ניהול", path: "/ניהול" }] : []),
    ...(isVendor && !isAdmin ? [{ icon: Store, label: "ספקים", path: "/פורטל-ספקים" }] : []),
    { icon: Coins, label: "נקודות", path: user ? "/פרופיל" : "/כניסה" },
    { icon: ShoppingCart, label: "עגלה", path: "__cart__" },
  ];

  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-background/95 backdrop-blur-md border-t md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => {
          const isCart = tab.path === "__cart__";
          const isActive = !isCart && location.pathname === tab.path;
          const Icon = tab.icon;

          if (isCart) {
            return (
              <button
                key={tab.label}
                onClick={() => openCart(true)}
                className="flex flex-col items-center gap-0.5 py-1 px-2 relative"
              >
                <div className="relative">
                  <Icon size={22} className="text-muted-foreground" />
                  {itemCount > 0 && (
                    <span className="absolute -top-1.5 -right-2 bg-destructive text-destructive-foreground text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                      {itemCount}
                    </span>
                  )}
                </div>
                <span className="text-[10px] text-muted-foreground">{tab.label}</span>
              </button>
            );
          }

          return (
            <Link
              key={tab.label}
              to={tab.path}
              className="flex flex-col items-center gap-0.5 py-1 px-2 relative"
            >
              {isActive && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="absolute -top-0.5 w-8 h-[3px] rounded-full bg-primary"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                />
              )}
              <div className="relative">
                <Icon
                  size={22}
                  className={isActive ? "text-primary" : "text-muted-foreground"}
                />
                {tab.label === "נקודות" && user && pointsBalance > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 gradient-primary text-primary-foreground text-[8px] font-bold rounded-full px-1 min-w-[16px] h-[14px] flex items-center justify-center">
                    {pointsBalance > 999 ? "999+" : pointsBalance}
                  </span>
                )}
              </div>
              <span
                className={`text-[10px] font-medium ${isActive ? "text-primary" : "text-muted-foreground"}`}
              >
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
